import React, { useState, useEffect } from 'react';
import {
  Row, Col, Button, Layout, Popconfirm, Table, Tooltip
} from 'antd';
import {
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import 'antd/dist/antd.css';
import moment from 'moment';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

const DocumentUploadTable = (props) => {
  const { t } = useTranslation()
  const tableIDName = "user_upload_id";
  let {
    dataObj, setModalVisible, setSelectedRecord, loading, deleteRecord, isActiveChangeCallBack, disableEdit
  } = props

  const [filterDataList, setFilterDataList] = useState([]);
  const [dataList, setDataList] = useState([]);


  useEffect(() => {
    setDataList(props.dataObj);
    setFilterDataList(props.dataObj);
  }, [dataObj]);

  const setTableHeader = () => {
    let columns = [
      {
        title: t('user_id'),
        dataIndex: 'user_id',
        sorter: (a, b) => a.user_id - b.user_id
      },
      {
        title: t('remark'),
        dataIndex: 'remark',
        sorter: (a, b) => a.remark.localeCompare(b.remark)
      },
      {
        title: t('utime'),
        dataIndex: 'utime',
        sorter: (a, b) => a.utime - b.utime,
        render: (value) => moment.unix(value).format('YYYY-MM-DD HH:mm')
      },
    ];
    if (!disableEdit) {
      columns.unshift({
        title: t('operation'),
        dataIndex: tableIDName,
        render: (value, record, key) => {
          return (
            <span>
              <Tooltip title={t('edit')}>
                <Button
                  shape="circle"
                  style={{ marginRight: 8}}
                  icon={<EditOutlined />}
                  onClick={() => {
                    setModalVisible(true);
                    setSelectedRecord(record)
                  }}
                />
              </Tooltip>
              <Popconfirm
                title={t('confirm_delete') + "?"}
                onConfirm={() => deleteRecord(record.user_upload_id)}
                okText={t('yes')}
                cancelText={t('no')}
              >
                <Tooltip title={t('delete')}>
                  <Button
                    shape="circle"
                    icon={<DeleteOutlined />}
                  />
                </Tooltip>
              </Popconfirm>
            </span>
          )
        }
      });
    }
    return columns;
  }

  return (
    <>
      <Row>
        {
          disableEdit ? '' : (
            <Col>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                style={{ marginBottom: 10 }}
                onClick={() => {
                  setModalVisible(true)
                  setSelectedRecord({user_upload_id: 0})
                }}
              >
                {t('upload')}
              </Button>
            </Col>
          )
        }
      </Row>
      <Layout>
        <Table
          rowKey={tableIDName}
          scroll={{ x: 'max-content' }}
          dataSource={filterDataList}
          columns={setTableHeader()}
          bordered
          size="small"
          pagination={{pageSize: 100}}
          loading={loading}
        />
      </Layout>
    </>
  )
}

export default DocumentUploadTable;
